/**
 * Converts street address into format of "Seattle, WA"
 * Useful for public profile level location anonymity.
 */
export const formatCityState = ({ city, state }) => [city, state].filter((s) => s && !!s.trim()).join(", ");
//# sourceMappingURL=formatAddress.js.map